<template>
  <div class="wrapper-setting">
    <div class="col">
      <el-row>
        <el-col :span="5">
          <div class="bg-white min-height">
            <home-sidebar active_item="password"></home-sidebar>
          </div>
        </el-col>
        <el-col :span="19">
          <div class="bg-white min-height ml-3">
            <div class="pt-3">
              <el-form :model="changeForm" status-icon ref="changeForm" label-width="100px"
                       style="padding-right:50px;">
                <el-form-item label="原密码" prop="oldPwd">
                  <el-input type="password" v-model="changeForm.oldPwd" auto-complete="off" class="item_w"></el-input>
                </el-form-item>
                <el-form-item label="新密码" prop="painpwd">
                  <el-input type="password" v-model="changeForm.painpwd" auto-complete="off" class="item_w"></el-input>
                </el-form-item>
                <el-form-item label="确认新密码" prop="newPwd">
                  <el-input type="password" v-model="changeForm.newPwd" auto-complete="off" class="item_w"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button @click.native="clk_update_pass" type="primary">确定修改</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import api from "../../api/rest";
import util from "../../api/util";
import HomeSidebar from "../../components/HomeSidebar.vue";

export default {
  components: {HomeSidebar},
  data() {
    return {
      changeForm: {}
    }
  },
  methods: {
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    clk_update_pass() {
      let para = Object.assign({}, this.changeForm)
      api.admin.updatePassword(para).then((res) => {
        this.$message({
          title: res.title,
          message: res.message,
          type: res.status
        })
        this.dlg_change_pass = false
      }).catch((res) => {
        api.handError.action(this, res)
      })
    },
  },
  filters: {
    formatMoney(num) {
      num = num / 10000
      return num.toString().replace(/\d+/, function (n) {
        return n.replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
      }) + "万";
    },
    formatDateTime(time) {
      var date = new Date(time)
      return date.format("yyyy-MM-dd")
    }
  },
  mounted() {
  }
}
</script>


// WEBPACK FOOTER //
// Password.vue?4c758b28